import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { AuthService } from '../_services/auth.service';
import { AlertService } from '../_services/alert.service';
import { NgxSpinnerService } from "ngx-spinner";
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { UserService } from '../_services/user/user.service';
import { CorporateService } from '../_services/corporate/corporate.service';
import { Slider } from 'ngx-slider';


@Component({
  templateUrl: 'login2.component.html',
  styleUrls: ['./login2.component.css']
})
export class Login2Component implements OnInit {
  loginForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  email: any;
  password: any;
  currentUser: any;
  hide: boolean = true;
  public slider = new Slider();


  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private spinner: NgxSpinnerService,
    private alertService: AlertService,
    private userService: UserService,
    public authService: AuthService,
    private corporateService: CorporateService,

  ) {
        this.slider.config.loop = true;
        this.slider.config.showPreview = false;
        this.slider.config.transitionDuration = 1;
        this.slider.config.showNavigator = false;
 }

  ngOnInit() {
    this.email = "";
    this.password = '';
    this.loginForm = this.formBuilder.group({
      email: ['', Validators.required],
      password: ['', Validators.required],
      rememberMe: true
    });
    // Remember Me
    if (localStorage.getItem('remember')) {
      // this.renderer.removeClass(document.body, 'bg-full-screen-image');
      localStorage.removeItem('currentLayoutStyle');
      this.router.navigate(['/dashboard']);
    } else if (localStorage.getItem('currentUser')) {
      // Force logout on login if not remember me
      // this.authService.doLogout();
      // this.isPageLoaded = true;
    } else {
      // this.isPageLoaded = true;
    }

          const slideItems = [
           { src: '../../assets/images/travel-flow-1024x533.png' },
           { src: '../../assets/images/banner2_2x.jpg' }
           // { src: 'https://placeimg.com/600/600/any' },
           // { src: 'https://placeimg.com/600/600/nature' },
           // { src: 'https://placeimg.com/600/600/sepia'},
           // { src: 'https://placeimg.com/600/600/people' },
           // { src: 'https://placeimg.com/600/600/tech' }
        ];

        this.slider.items = slideItems;

  }

  eyeFunction() {
  this.hide = !this.hide;
      }

  // convenience getter for easy access to form fields
  get f() { return this.loginForm.controls; }

  tryLogin() {

    this.spinner.show();
    this.submitted = true;

    // stop here if form is invalid
    if (this.loginForm.invalid) {
      this.spinner.hide();
      return;
    }
    const value = {
      email: this.f.email.value,
      password: this.f.password.value
    };
    this.authService.doLogin(value)
      .then(res => {
        console.log('after login ', res, this.currentUser);

        // this.setUserInStorage(res);
        this.getCurrentUser(res.user.uid)
          .then(() => {
            if(!this.currentUser){
              this.spinner.hide();
              this.submitted = false;
              this.alertService.showError('No User Account found !!', '5000', 'Contact Admin');
              return false;
            }
            if (this.currentUser && this.currentUser.id && !this.currentUser.mailVerified) {
              this.currentUser.mailVerified = true;
              this.spinner.hide();
              localStorage.setItem('currentUser', JSON.stringify(this.currentUser))
              this.userService.updateUser(this.currentUser.id, this.currentUser)
            }
            if (this.currentUser.isActive) {
              localStorage.removeItem('currentLayoutStyle');
              this.spinner.hide();
              let returnUrl = '/dashboard';
              if (this.returnUrl) {
                returnUrl = this.returnUrl;
              }
              this.userService
                .getUserRole(this.currentUser.roleValue)
                .subscribe((res: any) => {
                  console.log("curr user permissions ", res);

                  if (res && res.length) {
                    window.localStorage.setItem(
                      "permissions",
                      JSON.stringify(res[0].permissions)
                    );
                  }
                  this.router.navigate([returnUrl]);
                });
              if (this.currentUser.organization == 'CORPORATE') {
                let uid = this.currentUser.tenantId || this.currentUser.uid
                this.corporateService.getCorporateByTenantId(uid)
                  .then((org: any) => {
                    console.log('tenant corporate ', org);
                    if (org && org.length) {
                      window.localStorage.setItem(
                        "currOrganization",
                        JSON.stringify(org[0])
                      );
                    }
                  })
              } else if (this.currentUser.organization == 'HOTEL') {
                let uid = this.currentUser.tenantId || this.currentUser.uid
                this.corporateService.getHotelByTenantId(uid)
                  .then((org: any) => {
                    console.log('tenant hotel ', org);
                    if (org && org.length) {
                      window.localStorage.setItem(
                        "currOrganization",
                        JSON.stringify(org[0])
                      );
                    }
                  })
              }
            } else {
              this.spinner.hide();
              this.submitted = false;
              this.alertService.showError('Account has been suspended !!', '5000', 'Contact Admin');
            }
          })
      }, err => {
        this.spinner.hide();
        this.submitted = false;
        this.alertService.error(err.message);
      });
  }

  setUserInStorage(res) {
    if (res.user) {
      localStorage.setItem('currentUser', JSON.stringify(res.user));
    } else {
      localStorage.setItem('currentUser', JSON.stringify(res));
    }
  }

  simpleAlert() {
    Swal.fire('forget password');
  }

  getCurrentUser(uid: any) {
    return new Promise<void>((resolve) => {
      this.userService.getUserById(uid)
        .then((res: any) => {
          console.log('user after :: login ', res);
          if (res && res.length) {
            this.currentUser = res[0];
            localStorage.setItem('currentUser', JSON.stringify(this.currentUser))
          }
          resolve();
        })
    })
  }

  getJsonData() {
    // this.userService.getJsonData().subscribe(data=>{
    //   console.log(data)
    // });
  }

  // images = [101,155].map((n) => `https://picsum.photos/id/${n}/900/360`);
  images = ['../../assets/images/travel-flow-1024x533.png','../../assets/images/travel-concept-idea.jpg'];





}
